import Icon from '../components/Icon.vue'

Icon.register({
  terminal: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M258 273l-194.3 194.3c-9.4 9.4-24.6 9.4-33.9 0l-22.7-22.7c-9.4-9.4-9.4-24.5 0-33.9l154-154.7-154-154.7c-9.3-9.4-9.3-24.5 0-33.9l22.7-22.7c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9zM640 456c0 13.3-10.7 24-24 24h-304c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h304c13.3 0 24 10.7 24 24v32z'
      }
    ]
  }
})
